import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { MAC_APPS } from "@/lib/macLookup";

const label = (k) => (MAC_APPS.find(([a]) => a === k) || [k, k])[1];
const when = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

export const MacImportReport = () => {
  const [apps, setApps] = useState([]);
  const [run, setRun] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/macs/import/report").then((r) => { setApps(r.data.apps || []); setRun(r.data.run); }).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, []);

  const running = run?.status === "running";
  const start = async () => {
    setBusy(true);
    try {
      const r = await api.post("/macs/import/run");
      toast[r.data.status === "running" ? "info" : "success"](r.data.status === "running" ? "Importação já em andamento" : "Importação iniciada");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao iniciar"); }
    setBusy(false);
  };

  const sum = (k) => apps.reduce((a, x) => a + (x.totals?.[k] || 0), 0);
  const last = apps.map((x) => x.at).sort().pop();

  return (
    <div data-testid="mac-import-report" className="mt-2 rounded-lg border border-[#1F293D] bg-[#0F141F] p-2">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-slate-400">
        <button data-testid="mac-import-toggle" onClick={() => setOpen(!open)} className="flex flex-1 flex-wrap items-center gap-x-3 gap-y-1 text-left">
          <span>Importação{running ? " (rodando…)" : ""}: <b className="text-slate-200">{when(last)}</b></span>
          <span data-testid="mac-import-saved" className="text-emerald-300">{sum("saved")} MACs novos</span>
          <span>{sum("matched")} no CRM</span>
          {sum("extra") > 0 && <span data-testid="mac-import-extra" className="text-sky-300">{sum("extra")} extras</span>}
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </button>
        <button data-testid="mac-import-run" disabled={busy || running} onClick={start}
          className="inline-flex items-center gap-1 rounded-md border border-pink-500/40 px-2 py-1 font-semibold text-pink-300 transition-colors hover:bg-pink-500/10 disabled:opacity-50">
          {busy || running ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5" />} Importar agora
        </button>
      </div>
      {open && (
        <div className="mt-2 text-[11px] text-slate-500">
          {MAC_APPS.map(([k]) => {
            const a = apps.find((x) => x.app === k);
            const p = run?.progress?.[k];
            return (
              <div key={k} data-testid={`mac-import-app-${k}`} className="flex flex-wrap gap-x-2">
                <b className="text-slate-300">{label(k)}:</b>
                {p && !p.ok ? <span className="text-red-300">{p.error}</span>
                  : <span>{a?.totals?.saved || 0} novos + {a?.totals?.extra || 0} extras / {a?.totals?.rows || 0} lidos ({when(a?.at)})</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
